"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactSizeme = require("react-sizeme"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    _uiKit = require("@devsta/ui-kit"),
    _reactResponsive = _interopRequireDefault(require("react-responsive")),
    _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name")),
    _AssetPreview = _interopRequireDefault(require("../../../../AssetPreview")),
    _AssetDetails = _interopRequireDefault(require("./AssetDetails")),
    _utils = require("../utils"),
    _constants = require("../../../constants");

require("../styles/_asset-list-item.scss");

var getDate = (0, _memoizeOne["default"])(function (a) {
  var b = (0, _moment["default"])(a, ["x", "YYYY-MM-DDTHH:mm:ss.sssZ"]),
      c = b.format("DD MMM YYYY"),
      d = b.format("h:mma z");
  return "".concat(c, " at ").concat(d);
});

function AssetsListItem(a) {
  var b = a.item,
      c = a.handleClick,
      d = a.options;
  return _react["default"].createElement(_reactSizeme.SizeMe, null, function (a) {
    var e = a.size;
    return _react["default"].createElement(_uiKit.List.ListItem, {
      key: b.assetId,
      actionPopupOptions: d,
      hideImage: !0,
      onClick: c
    }, _react["default"].createElement("div", {
      className: (0, _classnames["default"])("library-list-item", {
        "library-list-item--small": e.width < _constants.mediaSizes.small
      })
    }, _react["default"].createElement("div", {
      className: "library-list-item__column"
    }, _react["default"].createElement(_AssetPreview["default"], (0, _utils.getAssetPreviewProps)({
      asset: b
    })), _react["default"].createElement(_AssetDetails["default"], {
      title: b.title,
      subTitle: b.description,
      fileName: b.filename
    })), _react["default"].createElement("div", {
      className: "library-list-item__column"
    }, _react["default"].createElement(_reactResponsive["default"], {
      minWidth: _vars.NUMERIC_MEDIA_SIZES.small + 1
    }, _react["default"].createElement(_uiKit.List.ListItem.UserDetails, {
      userName: (0, _getUserFullName["default"])(b.updatedByUser),
      profileImage: b.updatedByUser && b.updatedByUser.imageUrl
    }, _react["default"].createElement("p", {
      className: "library-list-item__job-title"
    }, b.updatedByUser && b.updatedByUser.jobTitle))), _react["default"].createElement("div", {
      className: "library-list-item__date"
    }, _react["default"].createElement("div", {
      className: "library-list-item__date__timestamp"
    }, _react["default"].createElement("p", {
      className: "library-list-item__date__timestamp__text"
    }, getDate(b.updatedAt))), _react["default"].createElement("p", {
      className: "library-list-item__date__text"
    }, "Last Updated")))));
  });
}

var _default = (0, _react.memo)(AssetsListItem);

exports["default"] = _default;